/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IListenerDataInfo {
    count: number;
    list: IUserInfo[];
}

export interface IInput {
    sessionId: string;
}

export interface IOutput {
    listened: IListenerDataInfo;
    listening: IListenerDataInfo;
}

export const getWeikeListenerInfo = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.WEIKE_LISTENER_INFO, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
